//基础框架&样式
import Vue from 'vue'
import ElementUI from 'element-ui'
import _ from 'lodash'
import 'element-ui/lib/theme-chalk/index.css';
import '../static/iconfont/iconfont.css'
import './scss/app.scss'
import './scss/base.scss'
//组件&类库
import skyUpload from 'sky-upload'
import commonApi from "@/services/common"
import OATable from '@/components/OATable'
import OAButton from '@/components/OAButton'
import permission from "@/directive/v-permission"
import OSS from 'ali-oss'
import skyRequest from 'skytech-request'

import {
  ssoInit
} from "@/common/ssoInit.js"

Vue.use(ElementUI)
Vue.use(OATable)
Vue.use(OAButton)
Vue.use(permission)
Vue.prototype.$env = process.env.NODE_ENV

Vue.use(skyUpload, { request: skyRequest, OSS, getHost: window.getDomain });

ssoInit(Vue)



// WEBPACK FOOTER //
// ./src/main.js